import { render, staticRenderFns } from "./WalletOpenButton.vue?vue&type=template&id=a9b68e3c&scoped=true"
import script from "./WalletOpenButton.vue?vue&type=script&lang=js"
export * from "./WalletOpenButton.vue?vue&type=script&lang=js"
import style0 from "./WalletOpenButton.vue?vue&type=style&index=0&id=a9b68e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b68e3c",
  null
  
)

export default component.exports